import React, { useContext } from 'react';
import cn from 'classnames';
import ConfigContext from '../../../contexts/ConfigContext';

import styles from './WhyBookWithUs.module.postcss';

function WhyBookWithUs({ title }) {
  const { site_title, logo, vehicle_type, city_name } = useContext(ConfigContext);

  const UsVsOthers = (
    <>
      <div className={cn(styles.WhyItem, styles.WhyItem__us)}><span className='icon icon-approved' /></div>
      <div className={cn(styles.WhyItem, styles.WhyItem__others)}><span className='icon icon-denied' /></div>
    </>
  );

  return (
    <section className='Section'>
      <div className={styles.WhyBook}>
        <h2 className='u-textCenter'>{ title || 'Why Book With Us?'}</h2>
        <div className={styles.WhyGrid}>

          <div className={cn(styles.WhyItem, styles.WhyHeader, styles.WhyItem__desc)}/>
          <div className={cn(styles.WhyItem, styles.WhyHeader, styles.WhyItem__us)}>
            <img src={logo} alt={site_title} width='150' height='25' />
          </div>
          <div className={cn(styles.WhyItem, styles.WhyHeader, styles.WhyItem__others)}>
            Others
          </div>

          <div className={cn(styles.WhyItem, styles.WhyItem__desc)}>
            <span className='u-mobileOnly'>Free to Use</span>
            <span className='u-noMobile'><strong>Completely Free to Use</strong> – No service fees, no hidden costs.</span>
          </div>
          { UsVsOthers }

          <div className={cn(styles.WhyItem, styles.WhyItem__desc)}>
            <span className='u-mobileOnly'>Direct Booking</span>
            <span className='u-noMobile'><strong>Direct Booking with Food {vehicle_type}s</strong> – Talk directly with vendors, no middlemen.</span>
          </div>
          { UsVsOthers }

          <div className={cn(styles.WhyItem, styles.WhyItem__desc)}>
            <span className='u-mobileOnly'>Compare Options</span>
            <span className='u-noMobile'><strong>Compare Multiple Food {vehicle_type}s Easily</strong> – Get bids from vendors and choose your favorite.</span>
          </div>
          { UsVsOthers }

          <div className={cn(styles.WhyItem, styles.WhyItem__desc)}>
            <span className='u-mobileOnly'>Diverse Cuisine</span>
            <span className='u-noMobile'><strong>Diverse Cuisine Options</strong> – Find everything from gourmet tacos to wood-fired pizza.</span>
          </div>
          { UsVsOthers }

          <div className={cn(styles.WhyItem, styles.WhyItem__desc)}>
            <span className='u-mobileOnly'>No Commissions</span>
            <span className='u-noMobile'><strong>No Commissions = Better Pricing</strong> – You pay the food truck directly, no markup.</span>
          </div>
          { UsVsOthers }

          <div className={cn(styles.WhyItem, styles.WhyItem__desc)}>
            <span className='u-mobileOnly'>Trusted by Top Companies</span>
            <span className='u-noMobile'><strong>Trusted by {city_name}&#39;s Top Companies & Event Planners</strong></span>
          </div>
          { UsVsOthers }

          <div className={cn(styles.WhyItem, styles.WhyHeader)}/>
          <div className={cn(styles.WhyItem, styles.WhyHeader, styles.WhyItem__us)}/>
          <div className={cn(styles.WhyItem, styles.WhyHeader)}/>

        </div>
      </div>
    </section>
  );
}

export default WhyBookWithUs;
